import {
  ARCHIVE_PRODUCT_SUCCESS,
  ARCHIVE_PRODUCT_FAILURE,
  GET_ARCHIVED_PRODUCTS_SUCCESS,
  GET_ARCHIVED_PRODUCTS_FAILURE,
  UNARCHIVE_PRODUCT_SUCCESS,
  UNARCHIVE_PRODUCT_FAILURE,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
  SHOW_PRODUCT_INDEX,
  TOGGLE_PRODUCT_REQUEST,
  TOGGLE_PRODUCT_SUCCESS,
  TOGGLE_PRODUCT_FAILURE,
  // SHOW_CREATE_PRODUCT_FORM,
  // CREATE_PRODUCT_REQUEST,
  // CREATE_PRODUCT_RESPONSE,
  // SHOW_EDIT_PRODUCT_FORM,
  // DELETE_PRODUCT_REQUEST,
  // DELETE_PRODUCT_RESPONSE,
  SET_PRODUCT_WIZARD_IS_VISIBLE,
  PATCH_PRODUCT_REQUEST,
  PATCH_PRODUCT_SUCCESS,
  PATCH_PRODUCT_FAILURE,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_FAILURE,
  INITIATE_CREATE_PRODUCT,
  GET_PRODUCT_INFORMATION,
  RESET_PRODUCT_REDUCER_STATE,
  CREATE_PRODUCT_SUCCESS,
  LINK_PRODUCT_WITH_CATEGORIES_SUCCESS,
  GET_PRODUCT_CATEGORIES_SUCCESS,
  GET_PRODUCT_VARIANTS_SUCCESS,
  UPDATE_PRODUCT_VARIANT_INITIAL_VALUES,
  RESET_PRODUCTION_VARIANT_INITIAL_VALUES,
  PUT_PRODUCT_VARIANTS_SUCCESS,
  GET_PRODUCT_OPTIONS_SUCCESS,
  PUT_PRODUCT_OPTIONS_SUCCESS,
  UPDATE_PRODUCT_TOGGLES,
  GET_PRODUCT_BUSINESS_SUCCESS,
  UPDATE_PRODUCT_BUSINESSES,
  GET_PRODUCT_TAGS_SUCCESS,
  PUT_PRODUCT_TAGS_SUCCESS,
  SET_PRODUCT_PREVIEW_FLAT_PRODUCT,
  CHANGE_VARIANT,
  INCREMENT_ITEM,
  DECREMENT_ITEM,
  INCREMENT_SUB_ITEM,
  DECREMENT_SUB_ITEM,
  VALIDATE_OPTION,
  GET_SELECTED_BUSINESS_REQUESTING,
  GET_SELECTED_BUSINESS_SUCCESS,
  GET_SELECTED_BUSINESS_FAILURE,
  PUT_SELECTED_BUSINESS_SUCCESS,
  UPDATE_SORTED_PRODUCTS_LIST,
  GET_PRODUCT_OVERRIDES,
  GET_PRODUCT_ASSIGNED_BUSINESSES,
  SUBMIT_PRODUCT_OVERRIDES_REQUEST,
  SUBMIT_PRODUCT_OVERRIDES,
  GET_PRODUCT_VARIANTS_REQUEST,
  SCAN_AND_GO,
  ALL_ORDER_TYPE_ID,
  GET_PRODUCT_AVAILABILITIES,
  PATCH_PRODUCT_AVAILABILITIES,
  GET_PRODUCTS_VARIANTS_SUCCESS,
  GET_ARCHIVED_PRODUCTS_REQUEST,
  GET_PRODUCT_VARIANTS_BY_BUSINESS,
  GET_PRODUCTS_VARIANTS_By_BUSINESSES_SUCCESS,
} from './productsTypes';
import { api } from '../../../api';
import { createAlert } from '../../Alert/actions';
import { normalize, schema } from 'normalizr';
import moment from 'moment';
import {
  getProductsMappingFields,
  getProductPosMappingValues,
} from '../POSMapping/posAction';
import ReactGA from 'react-ga';
import { formatErrorMessage } from '../../../utils/formatErrorMessage';
import { getSearchUrl } from '../../../utils/purePayload';
import { has } from 'lodash';
const sub_item = new schema.Entity('sub_items');

const item = new schema.Entity('items', {
  sub_items: [sub_item],
});

const sub_option = new schema.Entity('sub_options', {
  items: [item],
});

const option = new schema.Entity('options', {
  sub_options: [sub_option],
  items: [item],
});

const normalizeOptions = (originalOptions) =>
  normalize(originalOptions, [option]);
// for filter product variants modal
export function getProductsVariants(
  requestParams = {
    page_number: 1,
    page_size: '25',
    sorting_option: 'title-asc',
    search_string: '',
    has_next_page: true,
  }
) {
  return function (dispatch) {
    dispatch({ type: GET_PRODUCTS_REQUEST });
    const urlWithoutSearch = `/menu/products?page_number=${requestParams.page_number}&page_size=${requestParams.page_size}&include=prices`;
    const url = getSearchUrl(urlWithoutSearch, requestParams.search_string, 3);
    return api.get(url).then(
      (response) => {
        const hasNextPage = response.data.meta.has_next_page;
        dispatch({
          type: GET_PRODUCTS_VARIANTS_SUCCESS,
          allProductVariants: response.data.data,
          hasNextPage: hasNextPage,
        });
      },
      (error) => {
        ReactGA.event({
          category: 'Unsuccessful Response',
          action: 'Getting Products',
          label: 'Unsuccessfully Getting Products',
        });
        dispatch({ type: GET_PRODUCTS_FAILURE, error });
      }
    );
  };
}
export function getProducts(
  requestParams = {
    page_number: 1,
    page_size: '25',
    sorting_option: 'title-asc',
    search_string: '',
    has_next_page: true,
  }
) {
  return function (dispatch) {
    dispatch({ type: GET_PRODUCTS_REQUEST });
    const startTime = moment();
    const urlwithOutSearchString = `menu/products?page_number=${requestParams.page_number}&page_size=${requestParams.page_size}&include=upcs`;
    const url = getSearchUrl(
      urlwithOutSearchString,
      requestParams.search_string,
      3
    );

    return api.get(url).then(
      (response) => {
        const hasNextPage = response.data.meta.has_next_page;
        dispatch({
          type: GET_PRODUCTS_SUCCESS,
          response: response.data.data,
          hasNextPage: hasNextPage,
        });
        const endTime = moment();
        const responseTime = endTime.diff(startTime, 'millisecond');
        ReactGA.timing({
          category: 'Response Time',
          variable: 'Fetching',
          value: responseTime,
          label: 'Getting Products Response Time',
        });
        ReactGA.event({
          category: 'Successful Response',
          action: 'Getting Products',
          label: 'Successfully Getting Products',
        });
      },
      (error) => {
        ReactGA.event({
          category: 'Unsuccessful Response',
          action: 'Getting Products',
          label: 'Unsuccessfully Getting Products',
        });
        dispatch({ type: GET_PRODUCTS_FAILURE, error });
      }
    );
  };
}
export function getSelectedBusinesses(id) {
  return function (dispatch) {
    return api.get(`/menu/products/${id}/businesses`).then(
      (response) => {
        const productSelectedBusinessesInitialValues = response.data.data;
        dispatch({
          type: GET_SELECTED_BUSINESS_SUCCESS,
          productSelectedBusinessesInitialValues,
        });
      },
      (error) => {
        dispatch(
          createAlert({
            type: 'Error',
            message:
              error?.response?.data?.errors?.message ||
              'Updating Product business was not successful',
          })
        );
      }
    );
  };
}

export function getProductsByBusinessIDs(businessIds) {
  return async function (dispatch) {
    dispatch({ type: GET_PRODUCT_VARIANTS_BY_BUSINESS });
    if (!Array.isArray(businessIds) || businessIds.length === 0) {
      dispatch({
        type: GET_PRODUCTS_VARIANTS_By_BUSINESSES_SUCCESS,
        allProductVariants: [],
        hasNextPage: false,
      });
      return { data: [] };
    }
    try {
      const requests = businessIds.map(async (businessId) => {
        const url = `menu/products?page_number=1&page_size=4000&include=upcs&business_id=${businessId}`;
        try {
          const response = await api.get(url);
          if (response && response.data && Array.isArray(response.data.data)) {
            return response.data.data;
          } else {
            console.warn(
              `Unexpected response format for businessId ${businessId}`
            );
            return [];
          }
        } catch (e) {
          console.error(
            `Failed to fetch products for businessId ${businessId}`,
            e
          );
          return [];
        }
      });
      const results = await Promise.all(requests);
      const allResultsMerged = results.flat();
      const uniqueProductsMap = new Map();
      for (const product of allResultsMerged) {
        if (product && product.id != null) {
          uniqueProductsMap.set(product.id, product);
        } else {
          console.warn('Product without valid id found:', product);
        }
      }
      const uniqueProducts = Array.from(uniqueProductsMap.values());
      console.log('uniqueProducts', uniqueProducts);
      dispatch({
        type: GET_PRODUCTS_VARIANTS_By_BUSINESSES_SUCCESS,
        allProductVariants: uniqueProducts,
        hasNextPage: false,
      });
      return { data: uniqueProducts };
    } catch (error) {
      console.error('Error fetching product data:', error);
      return { error };
    }
  };
}

export function clearProductsList() {
  return function (dispatch, getState) {
    dispatch({
      type: 'CLEAR_PRODUCT_LIST',
      allProducts: [],
    });
  };
}

export function putProductBusinesses(productBusinesses, cb) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;

    // if (productBusinesses.length === 0) {
    //   dispatch(
    //     createAlert({
    //       type: "error",
    //       message: "At least one business needs to be assigned",
    //     })
    //   );
    //   return;
    // }

    api
      .put(`/menu/products/${productId}/businesses`, {
        businesses: productBusinesses,
      })
      .then((response) => {
        dispatch({
          type: PUT_SELECTED_BUSINESS_SUCCESS,
          productSelectedBusinessesInitialValues: productBusinesses,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product business updated successfully',
          })
        );
        dispatch(getProductAssignedBusinesses(productId));
        cb && cb();
      });
  };
}

export function toggleProduct(id, is_active) {
  return function (dispatch) {
    dispatch({ type: TOGGLE_PRODUCT_REQUEST, id });
    return api.patch(`/menu/products/${id}`, { is_active }).then(
      (response) => {
        dispatch({ type: TOGGLE_PRODUCT_SUCCESS, id });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product was successfully updated ',
          })
        );
      },
      (error) => {
        dispatch({
          type: TOGGLE_PRODUCT_FAILURE,
          id,
          error,
        });
        dispatch(
          createAlert({
            type: 'error',
            message:
              error?.response?.data?.errors?.message ||
              'Cannot make product active if Price or POS Mapping is missing.',
            dangerouslySetInnerHTML: true,
          })
        );
      }
    );
  };
}

export function initiateCreateProduct() {
  return function (dispatch) {
    dispatch({
      type: INITIATE_CREATE_PRODUCT,
    });
  };
}
export function getProductAvailabilities(productId) {
  return function (dispatch) {
    return api
      .get(`/menu/products/${productId}?include=availabilities`)
      .then((response) => {
        dispatch({
          type: GET_PRODUCT_AVAILABILITIES,
          payload: response.data.data.availabilities,
        });
      });
  };
}
export function getProductInformation(productId) {
  return function (dispatch, getState) {
    Promise.all([
      api.get(`/menu/products/${productId}`),
      api.get(`/menu/products/${productId}/order-types`),
    ]).then((response) => {
      dispatch(setProductWizardIsVisible(true));
      let orderType = response[1].data.data.map((orderType) => orderType.id);
      if (orderType.length < 1) {
        orderType = [
          -1,
          ...getState().fullReducer.orderTypesList.map(
            (fullOrderType) => fullOrderType.id
          ),
        ];
      }
      dispatch({
        type: GET_PRODUCT_INFORMATION,
        editingProductId: productId,
        productToEdit: {
          is_points_enabled: response[0].data.data.is_points_enabled,
          name: response[0].data.data.name,
          label: response[0].data.data.label,
          user_description: response[0].data.data.user_description,
          image_url: response[0].data.data.image_url,
          start_time: response[0].data.data.start_time,
          end_time: response[0].data.data.end_time,
          start_datetime: response[0].data.data.start_datetime,
          end_datetime: response[0].data.data.end_datetime,
          taxCategoryId: null,
          orderType,
          is_combo_only: response[0].data.data.is_combo_only,
          is_alcoholic: response[0].data.data.is_alcoholic,
        },
        productInformation: response[0].data.data,
        productToggles: {
          is_featured: response[0].data.data.is_featured,
          is_available: response[0].data.data.is_available,
          is_active: response[0].data.data.is_active,
        },
      });
      if (
        getState().accountReducer.appMetaData.configuration
          .smoothpay_integration_enabled ||
        getState().accountReducer?.appMetaData?.configuration
          ?.require_tax_categories
      ) {
        api.get(`/menu/products/${productId}/taxes`).then((taxResponse) => {
          dispatch({
            type: 'GET_PRODUCT_TAX_ID',
            taxCategoryId: taxResponse.data.data.tax_category_id,
          });
        });
      } else {
        let orderType = response[1].data.data.map((orderType) => orderType.id);
        if (orderType.length < 1) {
          orderType = [
            -1,
            ...getState().fullReducer.orderTypesList.map(
              (fullOrderType) => fullOrderType.id
            ),
          ];
        }
        dispatch({
          type: GET_PRODUCT_INFORMATION,
          editingProductId: productId,
          productToEdit: {
            is_points_enabled: response[0].data.data.is_points_enabled,
            name: response[0].data.data.name,
            label: response[0].data.data.label,
            user_description: response[0].data.data.user_description,
            image_url: response[0].data.data.image_url,
            start_time: response[0].data.data.start_time,
            end_time: response[0].data.data.end_time,
            start_datetime: response[0].data.data.start_datetime,
            end_datetime: response[0].data.data.end_datetime,
            taxCategoryId: null,
            orderType,
            is_combo_only: response[0].data.data.is_combo_only,
            is_alcoholic: response[0].data.data.is_alcoholic,
          },
          productInformation: response[0].data.data,
          productToggles: {
            is_featured: response[0].data.data.is_featured,
            is_available: response[0].data.data.is_available,
            is_active: response[0].data.data.is_active,
          },
        });
      }
    });
  };
}

function getProductCategories(productId) {
  return function (dispatch, getState) {
    return api
      .get(`/menu/products/${productId}/categories`)
      .then((response) => {
        api
          .get(`/menu/categories?page_number=1&page_size=2000`)
          .then((globalCategories) => {
            const categories = globalCategories.data.data;
            let categoriesInitialValues = [];

            response.data.data.forEach((responseCategory) => {
              categories.forEach((category) => {
                if (category.id == responseCategory.category_id) {
                  categoriesInitialValues.push({
                    id: category.id,
                    position: responseCategory.position,
                    subCategoriesId: null,
                  });
                } else if (category.sub_categories) {
                  category.sub_categories.forEach((subCategory) => {
                    if (subCategory.id == responseCategory.category_id) {
                      let index = -1;
                      categoriesInitialValues.find((categoryToEdit, i) => {
                        if (categoryToEdit.id == category.id) index = i;
                      });
                      if (index > -1) {
                        categoriesInitialValues[index].subCategoriesId = [
                          ...categoriesInitialValues[index].subCategoriesId,
                          subCategory.id,
                        ];
                      } else {
                        categoriesInitialValues.push({
                          id: category.id,
                          position: responseCategory.position,
                          subCategoriesId: [subCategory.id],
                        });
                      }
                    }
                  });
                }
              });
            });

            dispatch({
              type: GET_PRODUCT_CATEGORIES_SUCCESS,
              categoriesInitialValues,
              categories,
            });
          });
      });
  };
}

const getEndDayOfWeek = (product) => {
  const startTime = moment(product.start_time);
  const endTime = moment(product.end_time);
  let endDayOfWeek = product.start_day_of_week;
  if (startTime.isAfter(endTime)) {
    endDayOfWeek = endDayOfWeek + 1 > 7 ? 1 : endDayOfWeek + 1;
  }
  return endDayOfWeek;
};

export function getProductVariants(productId, upcs) {
  return function (dispatch, getState) {
    api
      .get(`/menu/variants?page_number=1&page_size=2000`)
      .then((globalVariantsResponse) => {
        dispatch({ type: GET_PRODUCT_VARIANTS_REQUEST });
        dispatch({
          type: 'GET_VARIANTS_SUCCESS',
          allVariants: globalVariantsResponse.data.data,
        });
        api
          .get(`/menu/products/${productId}/prices`)
          .then((productVariantsResponse) => {
            dispatch({
              type: GET_PRODUCT_VARIANTS_SUCCESS,
              productVariantsInitialValues: productVariantsResponse.data.data
                .sort((a, b) =>
                  a.position < b.position ? -1 : a.position > b.position ? 1 : 0
                )
                .map((variant) => {
                  let variantUpc = upcs.find(
                    (upc) => upc.variant_id === variant.product_variant_id
                  );
                  return {
                    ...variant,
                    barcode: variantUpc ? variantUpc.upc : '',
                  };
                }),
            });
          });
      });
  };
}

export function initiateEditProductWizard(productToEdit) {
  if (!productToEdit.upcs) {
    productToEdit.upcs = [];
  }
  return function (dispatch) {
    dispatch(getProductAvailabilities(productToEdit.id));
    dispatch(getProductInformation(productToEdit.id));
    dispatch(getProductCategories(productToEdit.id));
    dispatch(getProductOptions(productToEdit.id));
    dispatch(getProductTags(productToEdit.id));
    dispatch(getSelectedBusinesses(productToEdit.id));
    dispatch(initiatePOSData(productToEdit.id));
    dispatch(getProductVariants(productToEdit.id, productToEdit.upcs));
  };
}

const initiatePOSData = (productId) => {
  return (dispatch, getState) => {
    const appConfig = getState().accountReducer.appMetaData.configuration;
    const posMappingFields = getState().posReducer.productsMappingFields;
    if (appConfig.pos_integration_enabled) {
      if (posMappingFields && posMappingFields.length > 0) {
        dispatch(getProductPosMappingValues(productId, posMappingFields));
      } else {
        dispatch(getProductsMappingFields(productId));
      }
    }
  };
};

export function setProductWizardIsVisible(productWizardIsVisible) {
  return {
    type: SET_PRODUCT_WIZARD_IS_VISIBLE,
    productWizardIsVisible,
  };
}

export function createProduct(productInformation, productAvailabilities) {
  return function (dispatch, getState) {
    dispatch({ type: CREATE_PRODUCT_REQUEST });
    const modifiedProductAvailibility = [];
    productAvailabilities.forEach((item) => {
      let newItem;
      if (item.isAvailableAllDay) {
        newItem = {
          start_time: '00:00:00',
          end_time: '23:59:59',
          start_day_of_week: item.start_day_of_week,
          end_day_of_week: getEndDayOfWeek(item),
        };
        modifiedProductAvailibility.push(newItem);
      } else if (item.end_time && item.start_time) {
        newItem = {
          start_time: moment(item.start_time).format('HH:mm:ss'),
          end_time: moment(item.end_time).format('HH:mm:ss'),
          start_day_of_week: item.start_day_of_week,
          end_day_of_week: getEndDayOfWeek(item),
        };
        modifiedProductAvailibility.push(newItem);
      }
    });
    const notAvailableList = productAvailabilities.filter(
      (item) => !item.end_time && !item.isAvailableAllDay
    );
    const notAvailableCount = notAvailableList?.length;
    let body = {
      ...productInformation,
      start_datetime: moment(productInformation.start_datetime).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      end_datetime: productInformation.end_datetime
        ? moment(productInformation.end_datetime).format('YYYY-MM-DD HH:mm:ss')
        : null,
      taxjar_code: 40030, // hard coded
      is_active: false, // false when initially created
      is_available: false, // false when initially created
      is_group_based: false, // hard coded
      is_featured: false, // false when initially created
    };
    if (!body?.end_datetime) {
      delete body.end_datetime;
    }
    if (!body?.label) {
      delete body.label;
    }
    if (notAvailableCount !== 7) {
      body = { ...body, availabilities: modifiedProductAvailibility };
    }
    delete body.taxCategoryId;
    delete body.orderType;
    const { businessLocationsOfMerchant } = getState().businessLocationsList;

    let allBusinesses = [];

    businessLocationsOfMerchant.forEach((business) => {
      if (business.sub_businesses.length) {
        business.sub_businesses.forEach((subBusiness) => {
          allBusinesses.push(subBusiness);
        });
      } else {
        allBusinesses.push(business);
      }
    });
    const productSelectedBusinessesInitialValues = allBusinesses.map(
      (business) => ({
        business_id: business.id,
        is_active: true,
        is_available: true,
      })
    );
    api
      .post(`/menu/products`, body)
      .then((response) => {
        api.put(`/menu/products/${response.data.data.id}/businesses`, {
          businesses: allBusinesses.map((business) => ({
            business_id: business.id,
            is_active: true,
            is_available: true,
          })),
        });

        let orderType = productInformation.orderType;
        if (orderType.includes(ALL_ORDER_TYPE_ID)) {
          orderType = [];
        }

        api.put(`/menu/products/${response.data.data.id}/order-types`, {
          order_types: orderType,
        });
        if (
          getState().accountReducer.appMetaData.configuration
            .smoothpay_integration_enabled ||
          getState().accountReducer?.appMetaData?.configuration
            ?.require_tax_categories
        ) {
          api.put(`/menu/products/${response.data.data.id}/taxes`, {
            tax_category_id: productInformation.taxCategoryId,
          });
        }

        dispatch(
          createAlert({
            type: 'success',
            message: 'Product information created successfully',
          })
        );
        ReactGA.event({
          category: 'Successful Response',
          action: 'Create Product',
          label: 'Successful Creating Product',
        });
        api
          .get(`/menu/variants?page_number=1&page_size=2000`)
          .then((globalVariantsResponse) => {
            dispatch({
              type: 'GET_VARIANTS_SUCCESS',
              allVariants: globalVariantsResponse.data.data,
            });

            api
              .get(`/menu/options?include=items&page_number=1&page_size=2000`)
              .then((globalOptionsResponse) => {
                dispatch({
                  type: 'GET_OPTIONS_SUCCESS_NORMALIZED',
                  response: normalizeOptions(globalOptionsResponse.data.data),
                });
                api
                  .get(`/menu/categories?page_number=1&page_size=2000`)
                  .then((globalCategories) => {
                    dispatch({
                      type: CREATE_PRODUCT_SUCCESS,
                      productId: response.data.data.id,
                      productInformation: {
                        ...productInformation,
                      },
                      categories: globalCategories.data.data,
                      productSelectedBusinessesInitialValues,
                      allOptions: globalOptionsResponse.data.data.map(
                        (option) => ({
                          id: option.id,
                          name: option.name
                            .toLowerCase()
                            .split(' ')
                            .map(
                              (s) => s.charAt(0).toUpperCase() + s.substring(1)
                            )
                            .join(' '),
                        })
                      ),
                    });
                    // update form valuse
                    dispatch({
                      type: PATCH_PRODUCT_SUCCESS,
                      productInformationInitialValues: {
                        availabilities: body.availabilities,
                        is_points_enabled: productInformation.is_points_enabled,
                        name: productInformation.name,
                        label: productInformation.label,
                        user_description: productInformation.user_description,
                        image_url: productInformation.image_url,
                        start_time: productInformation.start_time,
                        end_time: productInformation.end_time,
                        start_datetime: productInformation.start_datetime,
                        end_datetime: productInformation.end_datetime,
                        orderType: productInformation.orderType,
                        taxCategoryId: productInformation.taxCategoryId,
                        is_combo_only: productInformation.is_combo_only,
                        is_alcoholic: productInformation.is_alcoholic,
                      },
                    });

                    dispatch({
                      type: PATCH_PRODUCT_AVAILABILITIES,
                      productAvailabilities: body.availabilities,
                    });
                  });
              });
          });
      })
      .catch((error) => {
        ReactGA.event({
          category: 'Unsuccessful Response',
          action: 'Create Product',
          label: 'Unsuccessful Creating Product',
        });
        if (error.response.status === 500) {
          dispatch({
            type: CREATE_PRODUCT_FAILURE,
          });
          dispatch(
            createAlert({
              type: 'error',
              message:
                formatErrorMessage(error) || 'Product name is already taken',
              dangerouslySetInnerHTML: true,
            })
          );
        }
      });
  };
}

export function patchProduct(
  {
    productInformationWithFormattedTimes,
    productBusinesses,
    productAvailabilities,
  },
  productId
) {
  let body = {
    ...productInformationWithFormattedTimes,
    start_datetime: moment(
      productInformationWithFormattedTimes.start_datetime
    ).format('YYYY-MM-DD HH:mm:ss'),
    end_datetime: productInformationWithFormattedTimes.end_datetime
      ? moment(productInformationWithFormattedTimes.end_datetime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      : moment('2099-12-31 00:00:00').format('YYYY-MM-DD HH:mm:ss'),
  };
  // if (!body.end_datetime) {
  //   delete body.end_datetime;
  // }
  if (!body?.label) {
    delete body.label;
  }
  // if (!body.taxCategoryId) {
  // }
  delete body.taxCategoryId;
  delete body.orderType;
  delete body.availabilities;
  delete body.productIsProductAvailableAllTime;
  delete body.id;
  const productAvailableOption = {
    name: productInformationWithFormattedTimes.name,
    start_time: productInformationWithFormattedTimes.start_time,
    end_time: productInformationWithFormattedTimes.end_time,
    start_datetime: moment(
      productInformationWithFormattedTimes.start_datetime
    ).format('YYYY-MM-DD HH:mm:ss'),
    end_datetime: productInformationWithFormattedTimes.end_datetime
      ? moment(productInformationWithFormattedTimes.end_datetime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      : moment('2099-12-31 00:00:00').format('YYYY-MM-DD HH:mm:ss'),
    is_active: productInformationWithFormattedTimes.is_active,
    is_combo_only: productInformationWithFormattedTimes.is_combo_only,
    availabilities: productAvailabilities.map((products) => ({
      start_time:
        products.start_time !== undefined &&
        products.start_time !== null &&
        products.start_time != NaN &&
        products.end_time != 'NaN' &&
        products.end_time != 'Invalid date'
          ? moment(products.start_time).format('HH:mm:ss')
          : '00:00:00',
      end_time:
        products.end_time &&
        products.end_time != NaN &&
        products.end_time != 'NaN' &&
        products.end_time != 'Invalid date'
          ? moment(products.end_time).format('HH:mm:ss')
          : '00:00:00',
      start_day_of_week: products.start_day_of_week,
      end_day_of_week: getEndDayOfWeek(products),
    })),
  };
  // if (!productAvailableOption.end_datetime) {
  //   delete productAvailableOption.end_datetime;
  // }
  const notAvailableList = productAvailabilities.filter(
    (item) => !item.end_time && !item.isAvailableAllDay
  );
  const notAvailableCount = notAvailableList?.length;
  const trimProductAvailable = [];
  productAvailableOption.availabilities.forEach((products) => {
    if (products.start_time && products.end_time !== '00:00:00') {
      trimProductAvailable.push(products);
    } else {
      return;
    }
  });
  productAvailableOption.availabilities = trimProductAvailable;
  if (notAvailableCount === 7) {
    delete productAvailableOption.availabilities;
  }

  return function (dispatch, getState) {
    let orderType = productInformationWithFormattedTimes.orderType;
    if (orderType.includes(ALL_ORDER_TYPE_ID)) {
      orderType = [];
    }

    dispatch({ type: PATCH_PRODUCT_REQUEST });
    Promise.all([
      api.patch(`/menu/products/${productId}`, body),
      api.put(`/menu/products/${productId}/order-types`, {
        order_types: orderType,
      }),
      api.patch(`/menu/products/${productId}`, productAvailableOption),
      //api.patch(`/menu/products/${productId}`, body),
    ])
      .then((responses) => {
        // dispatch(
        //   createAlert({
        //     type: 'success',
        //     message: 'Product was successfully updated'
        //   })
        // );
        if (
          getState().accountReducer.appMetaData.configuration
            .smoothpay_integration_enabled ||
          getState().accountReducer?.appMetaData?.configuration
            ?.require_tax_categories
        ) {
          api.put(`/menu/products/${productId}/taxes`, {
            tax_category_id: productInformationWithFormattedTimes.taxCategoryId,
          });
        }
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product information updated successfully',
          })
        );

        dispatch({
          type: PATCH_PRODUCT_SUCCESS,
          productInformationInitialValues: {
            availabilities: productAvailableOption.availabilities,
            is_points_enabled:
              productInformationWithFormattedTimes.is_points_enabled,
            name: productInformationWithFormattedTimes.name,
            label: productInformationWithFormattedTimes.label,
            user_description:
              productInformationWithFormattedTimes.user_description,
            image_url: productInformationWithFormattedTimes.image_url,
            start_time: productInformationWithFormattedTimes.start_time,
            end_time: productInformationWithFormattedTimes.end_time,
            start_datetime: productInformationWithFormattedTimes.start_datetime,
            end_datetime: productInformationWithFormattedTimes.end_datetime,
            orderType: productInformationWithFormattedTimes.orderType,
            taxCategoryId: productInformationWithFormattedTimes.taxCategoryId,
            is_combo_only: productInformationWithFormattedTimes.is_combo_only,
            is_alcoholic: productInformationWithFormattedTimes.is_alcoholic,
          },
        });

        dispatch({
          type: PATCH_PRODUCT_AVAILABILITIES,
          productAvailabilities: productAvailableOption.availabilities,
        });
      })
      .catch((error) => {
        dispatch({
          type: PATCH_PRODUCT_FAILURE,
        });
        dispatch(
          createAlert({
            type: 'error',
            message: `unexpected error. error code ${error.response.status}`,
          })
        );
        if (error.response.status === 500) {
          dispatch(
            createAlert({
              type: 'error',
              message:
                error?.response?.data?.errors?.message ||
                'Product name is already taken',
            })
          );
        }
      });
  };
}

export function patchProductIsFeatured(is_featured) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    api
      .patch(`/menu/products/${productId}`, { is_featured })
      .then((response) => {
        dispatch({
          type: UPDATE_PRODUCT_TOGGLES,
          productToggles: { is_featured },
        });
      })
      .catch((error) => {
        if (error.response.status === 422) {
          dispatch(
            createAlert({
              type: 'error',
              message:
                error?.response?.data?.errors?.message ||
                'Cannot make product featured without POS Mapping',
            })
          );
        }
      });
  };
}

export function patchProductIsAvailable(is_available) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    api
      .patch(`/menu/products/${productId}`, { is_available })
      .then((response) => {
        dispatch({
          type: UPDATE_PRODUCT_TOGGLES,
          productToggles: { is_available },
        });
      })
      .catch((error) => {
        if (error.response.status === 422) {
          dispatch(
            createAlert({
              type: 'error',
              message:
                error?.response?.data?.errors?.message ||
                'Cannot make product available without POS Mapping',
            })
          );
        }
      });
  };
}

export function patchProductIsActive(is_active) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    api
      .patch(`/menu/products/${productId}`, { is_active })
      .then((response) => {
        dispatch({
          type: UPDATE_PRODUCT_TOGGLES,
          productToggles: { is_active },
        });
        dispatch(getProductInformation(productId));
      })
      .catch((error) => {
        if (error.response.status === 422) {
          dispatch(
            createAlert({
              type: 'error',
              message:
                error?.response?.data?.errors?.message ||
                'Cannot make product active without POS Mapping',
            })
          );
        }
      });
  };
}

export function putProductCategories(formCategories) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    let categories = [];
    let i = 0;

    formCategories.forEach((category) => {
      if (category.subCategoriesId) {
        category.subCategoriesId.forEach((subCategoryId) => {
          categories = [
            ...categories,
            {
              category_id: subCategoryId,
              position: category.position ? category.position : 125,
            },
          ];
        });
      } else {
        categories = [
          ...categories,
          {
            category_id: category.id,
            position: category.position ? category.position : 125,
          },
        ];
      }
    });

    api
      .put(`/menu/products/${productId}/categories`, { categories })
      .then((response) => {
        dispatch({
          type: LINK_PRODUCT_WITH_CATEGORIES_SUCCESS,
          categoriesInitialValues: formCategories,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product categories updated successfully',
          })
        );
      });
  };
}

export function updateProductVariantsInitialValues(
  productVariantsInitialValues
) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_PRODUCT_VARIANT_INITIAL_VALUES,
      productVariantsInitialValues,
    });
  };
}

export function putProductVariants(productVariants) {
  return function (dispatch, getState) {
    const appConfig = getState().accountReducer.appMetaData.configuration;
    let productId = getState().productsReducer.productId;
    let prices = productVariants.map((productVariant, index) => ({
      product_variant_id: productVariant.product_variant_id,
      price:
        typeof productVariant.price === 'number'
          ? productVariant.price
          : parseFloat(productVariant.price.replace('$', '')),
      is_active: productVariant.is_active,
      is_default: productVariant.is_default,
      position: index + 1,
    }));

    let upcs = productVariants
      .map((variant) => ({
        product_variant_id: variant.product_variant_id,
        upc: variant.barcode,
      }))
      .filter((upc) => upc.upc);

    let apis = [api.put(`/menu/products/${productId}/prices`, { prices })];

    if (
      getState().productsReducer.productInformationInitialValues.orderType.includes(
        SCAN_AND_GO
      )
    ) {
      apis = [...apis, api.put(`/menu/products/${productId}/upc`, { upcs })];
    }

    Promise.all(apis).then((responses) => {
      dispatch(
        getProductVariants(
          productId,
          upcs.map((upc) => ({
            variant_id: upc.product_variant_id,
            upc: upc.upc,
          }))
        )
      );
      dispatch(
        createAlert({
          type: 'success',
          message: 'Product variants updated successfully',
        })
      );
      if (appConfig.pos_integration_enabled) {
        dispatch(
          getProductPosMappingValues(
            productId,
            getState().posReducer.productsMappingFields
          )
        );
      }
    });
  };
}
const createOptionWithDefaultCustomization = (
  options,
  defaultCustomizations
) => {
  const optionsWithDefaultCusomization = options.reduce((acc, option) => {
    let selectedItems = null;
    const selectedDefaultCustomization = defaultCustomizations?.find(
      (defaultOption) => option.id === defaultOption.id
    );
    if (selectedDefaultCustomization) {
      selectedItems = selectedDefaultCustomization.items.reduce((acc, item) => {
        if (item.sub_items?.length > 0) {
          item.sub_items.forEach((sub) => acc.push(sub));
        } else {
          acc.push(item);
        }
        return acc;
      }, []);
    }
    let newOption = {
      option_id: option.id,
      option_name: option.name,
      option_items: [],
    };

    if (option?.items?.length > 0) {
      option.items.forEach((item) => {
        if (item?.sub_items.length > 0) {
          item.sub_items.forEach((subItem) => {
            const slectedItem = selectedItems?.find(
              (defItem) => defItem.id === subItem.id
            );
            newOption.option_items.push({
              parent_name: item.name,
              product_option_item_id: subItem.id,
              name: subItem.name,
              quantity: slectedItem?.quantity || 0,
              is_default: slectedItem?.is_default || false,
              maximum_pick: subItem.maximum_pick,
            });
          });
        } else {
          const slectedItem = selectedItems?.find(
            (defItem) => defItem.id === item.id
          );
          newOption.option_items.push({
            parent_name: '',
            product_option_item_id: item.id,
            name: item.name,
            quantity: slectedItem?.quantity || 0,
            is_default: slectedItem?.is_default || false,
            maximum_pick: item.maximum_pick,
          });
        }
      });
    } else if (option?.sub_options?.length > 0) {
      option.sub_options.forEach((suboption) => {
        suboption.items.forEach((item) => {
          if (item?.sub_items?.length > 0) {
            item.sub_items.forEach((subItem) => {
              const slectedItem = selectedItems?.find(
                (defItem) => defItem.id === subItem.id
              );
              newOption.option_items.push({
                parent_name: item.name,
                product_option_item_id: subItem.id,
                name: subItem.name,
                quantity: slectedItem?.quantity || 0,
                is_default: slectedItem?.is_default || false,
                maximum_pick: subItem.maximum_pick,
              });
            });
          } else {
            const slectedItem = selectedItems?.find(
              (defItem) => defItem.id === item.id
            );
            newOption.option_items.push({
              parent_name: '',
              product_option_item_id: item.id,
              name: item.name,
              quantity: slectedItem?.quantity || 0,
              is_default: slectedItem?.is_default || false,
              maximum_pick: item.maximum_pick,
            });
          }
        });
      });
    }
    acc.push(newOption);
    return acc;
  }, []);
  return optionsWithDefaultCusomization;
};
export function getProductOptions(productId) {
  return function (dispatch) {
    api
      .get(`/menu/options?include=items&page_number=1&page_size=1000`)
      .then((globalOptionsResponse) => {
        dispatch({
          type: 'GET_OPTIONS_SUCCESS_NORMALIZED',
          response: normalizeOptions(globalOptionsResponse.data.data),
        });
        api.get(`/menu/products/${productId}/options`).then((response) => {
          const allProductOptions = response.data.data.map(
            (item) => item.product_option_id
          );
          response.data.data.sort(
            (product1, product2) => product1.position - product2.position
          );
          const promises = allProductOptions.map((optionId) =>
            api.get(`/menu/options/${optionId}?include=items`)
          );
          return Promise.allSettled(promises).then((res) => {
            const optionItems = res.reduce((acc, curr) => {
              if (curr.status === 'fulfilled') {
                acc.push(curr.value.data.data);
              }
              return acc;
            }, []);

            api
              .get(`/menu/product/${productId}/default-customizations`)
              .then((resDefaultOptions) => {
                const defaultCustomization = resDefaultOptions.data.data;
                const optionWithDefault = createOptionWithDefaultCustomization(
                  optionItems,
                  defaultCustomization
                );
                dispatch({
                  type: GET_PRODUCT_OPTIONS_SUCCESS,
                  optionWithDefault,
                  productOptionsInitialValues: response.data.data
                    .map((productOption) => ({
                      product_option_id: productOption.product_option_id,
                      position: productOption.position,
                    }))
                    .sort((a, b) =>
                      a.position < b.position
                        ? -1
                        : a.position > b.position
                        ? 1
                        : 0
                    ),
                  allOptions: globalOptionsResponse.data.data.map((option) => ({
                    id: option.id,
                    name: option.name
                      .toLowerCase()
                      .split(' ')
                      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                      .join(' '),
                  })),
                });
              });
          });
        });
      });
  };
}

export function putProductOptions(productOptions) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    productOptions = productOptions.map((option) => ({
      product_option_id: option.product_option_id,
      position: option.position,
    }));
    api
      .put(`/menu/products/${productId}/options`, { options: productOptions })
      .then((response) => {
        dispatch(getProductOptions(productId));
        dispatch({
          type: PUT_PRODUCT_OPTIONS_SUCCESS,
          productOptionsInitialValues: productOptions,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product options updated successfully',
          })
        );
      });
  };
}
export function putProductOptionsDefaultCustomization(productOptions) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    api
      .put(`/menu/product/${productId}/default-customizations`, {
        option_items: productOptions,
      })
      .then((response) => {
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product options updated successfully',
          })
        );
      });
  };
}

export function getProductTags(productId) {
  return function (dispatch) {
    api.get(`/menu/products/${productId}/tags`).then((response) => {
      dispatch({
        type: GET_PRODUCT_TAGS_SUCCESS,
        productTagsInitialValues: response.data.data.map((tag) => tag.tag_id),
      });
    });
  };
}

export function putProductTags(productTags) {
  return function (dispatch, getState) {
    const { productId } = getState().productsReducer;
    api
      .put(`/menu/products/${productId}/tags`, { tags: productTags })
      .then((response) => {
        dispatch({
          type: PUT_PRODUCT_TAGS_SUCCESS,
          productTagsInitialValues: productTags,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product tags updated successfully',
          })
        );
      });
  };
}

export function setProductPreviewFlatProduct(value) {
  return function (dispatch, getState) {
    if (value === null) {
      dispatch({
        type: SET_PRODUCT_PREVIEW_FLAT_PRODUCT,
        productCustomizerReducer: null,
      });
    } else {
      const {
        productInformation,
        productInformationInitialValues,
        productToggles,
        categoriesInitialValues,
        productVariantsInitialValues,
        productOptionsInitialValues,
        allOptions,
        categories,
      } = getState().productsReducer;
      const { allVariants } = getState().variantsReducer;
      const { items, options, sub_items, sub_options } =
        getState().optionReducer.entities;
      let flatProduct = {};

      Object.keys(items).forEach((key) => {
        items[key] = { ...items[key], item_id: items[key].id };
        if (items[key].sub_items && !items[key].sub_items.length) {
          delete items[key].sub_items;
        }
      });

      Object.keys(sub_items).forEach((key) => {
        if (sub_items[key].sub_items && !sub_items[key].sub_items.length) {
          sub_items[key] = { ...sub_items[key], item_id: sub_items[key].id };
          delete sub_items[key].sub_items;
        }
      });

      let {
        id,
        relationships,
        is_available,
        is_active,
        taxjar_code,
        ...productInfo
      } = productInformation;

      flatProduct = {
        ...flatProduct,
        ...productInfo,
        ...productInformationInitialValues,
        ...productToggles,
        prices: productVariantsInitialValues.map((variant) => ({
          variant_id: variant.product_variant_id,
          price: variant.price,
          is_default: variant.is_default,
          position: variant.position,
          name: allVariants.find(
            (globalVariant) => globalVariant.id === variant.product_variant_id
          ).name,
        })),
        price: productVariantsInitialValues.find(
          (variant) => variant.is_default
        ).price,
        variant_id: productVariantsInitialValues.find(
          (variant) => variant.is_default
        ).product_variant_id,
        variant_name: allVariants.find(
          (globalVariant) =>
            globalVariant.id ===
            productVariantsInitialValues.find((variant) => variant.is_default)
              .product_variant_id
        ).name,
        product_id: productInformation.id,
        quantity: 1,
        is_product_available: productToggles.is_available,
        options: productOptionsInitialValues.map(
          (option) => option.product_option_id
        ),
        itemsById: items,
        optionsById: options,
        subOptionsById: sub_options,
        subItemsById: sub_items,
        calories: productVariantsInitialValues.map((variant) => ({
          variant_id: variant.product_variant_id,
          min_calories: 240,
          max_calories: 240,
          calories_unit: '',
        })),
      };

      dispatch({
        type: SET_PRODUCT_PREVIEW_FLAT_PRODUCT,
        productCustomizerReducer: {
          flatProduct,
          isEditing: false,
          requestGetProductToConfigure: false,
          selectedVariantId: flatProduct.variant_id,
          singlePrice: flatProduct.price,
          totalPrice: flatProduct.price * flatProduct.quantity,
        },
      });
    }
  };
}

export function changeVariant({ productId, variantId, businessId }) {
  return function (dispatch, getState) {
    let { productCustomizerReducer } = getState().productsReducer;
    productCustomizerReducer = {
      ...productCustomizerReducer,
      selectedVariantId: variantId,
      flatProduct: {
        ...productCustomizerReducer.flatProduct,
        prices: productCustomizerReducer.flatProduct.prices.map((variant) =>
          variant.variant_id === variantId
            ? { ...variant, is_default: true }
            : { ...variant, is_default: false }
        ),
      },
      singlePrice: productCustomizerReducer.flatProduct.prices.find(
        (variant) => variant.variant_id === variantId
      ).price,
      totalPrice:
        productCustomizerReducer.flatProduct.prices.find(
          (variant) => variant.variant_id === variantId
        ).price * productCustomizerReducer.flatProduct.quantity,
    };
    dispatch({ type: CHANGE_VARIANT, productCustomizerReducer });
  };
}

export function incrementItem(item) {
  return {
    type: INCREMENT_ITEM,
    item,
  };
}

export function decrementItem(item) {
  return {
    type: DECREMENT_ITEM,
    item,
  };
}

export function incrementSubItem(subItem) {
  return {
    type: INCREMENT_SUB_ITEM,
    subItem,
  };
}

export function decrementSubItem(subItem, quantity) {
  return {
    type: DECREMENT_SUB_ITEM,
    subItem,
    quantity,
  };
}

const updateOptionError = (option, flatProduct) => {
  const { subOptionsById, itemsById, subItemsById } = flatProduct;
  let selectedItemQuantity = 0;

  const iterateItems = (items) => {
    items.forEach((itemId) => {
      const item = itemsById[itemId];
      if (item.sub_items && item.sub_items.length) {
        item.sub_items.forEach((subItemId) => {
          const subItem = subItemsById[subItemId];
          selectedItemQuantity += subItem.quantity;
        });
      } else {
        selectedItemQuantity += item.quantity;
      }
    });
  };

  if (option.sub_options && option.sub_options.length) {
    option.sub_options.forEach((subOptionId) => {
      const subOption = subOptionsById[subOptionId];
      iterateItems(subOption.items);
    });
  } else {
    iterateItems(option.items);
  }
  return { ...option, error: selectedItemQuantity < option.minimum_pick };
};

export function validateOption(option, flatProduct) {
  return function (dispatch) {
    dispatch({
      type: VALIDATE_OPTION,
      validatedOption: updateOptionError(option, flatProduct),
    });
  };
}

export function resetProductReducerState() {
  return {
    type: RESET_PRODUCT_REDUCER_STATE,
  };
}

export function updateProductsRequestParams(requestParams) {
  return {
    type: 'UPDATE_PRODUCTS_REQUEST_PARAMS',
    payload: requestParams,
  };
}

export function updateSortedProductsList(productsList, sortOrder) {
  return {
    type: UPDATE_SORTED_PRODUCTS_LIST,
    allProducts: productsList,
    sortOrder: sortOrder,
  };
}

export function getProductOverrides(productId) {
  return function (dispatch) {
    api
      .get(`/menu/products/${productId}/business/override`, {
        ignore_interception: true,
      })
      .then((response) => {
        let overrides = [];
        for (let i = 0; i < 10000; i++) {
          const override = response.data.data[i];
          if (override && Object.keys(override).length > 0) {
            overrides.push(override);
          } else {
            break;
          }
        }
        dispatch({
          type: GET_PRODUCT_OVERRIDES,
          payload: overrides,
        });
      });
  };
}

export function getProductAssignedBusinesses(productId) {
  return function (dispatch, getState) {
    const allBusinesses =
      getState().businessLocationsList.businessLocationsOfMerchant;

    api.get(`/menu/products/${productId}/businesses`).then((response) => {
      const productSelectedBusinessesInitialValues = response.data.data
        .map((business) => (business.is_active ? business.business_id : null))
        .filter((id) => id);
      dispatch({
        type: GET_PRODUCT_ASSIGNED_BUSINESSES,
        payload: formatProductBusinessesAssigned(
          productSelectedBusinessesInitialValues,
          allBusinesses
        ),
      });
    });
  };
}

export function formatProductBusinessesAssigned(
  productsBusinesses,
  allBusinesses
) {
  let finalBusinessesArray;
  const set = new Set();
  productsBusinesses.forEach((data) => {
    set.add(data);
    // set.add(data.business_id);
  });

  //isDisabled field - a business is assigned or not
  finalBusinessesArray = allBusinesses.map((business) => ({
    ...business,
    ...((!set.has(business.id) || !business.is_active) && { isDisabled: true }),
  }));

  return finalBusinessesArray;
}

export function handleSubmitProductOverrides(
  productId,
  summaryData,
  values,
  isCreate,
  initialBusinesses,
  index,
  initialValues,
  touched,
  cb
) {
  return function (dispatch) {
    if (isCreate && !touched.prices) {
      dispatch(
        createAlert({
          type: 'error',
          message: 'Please modify the prices to save the overrides!',
        })
      );
      return;
    }

    const initialBusinessesIds =
      initialBusinesses && initialBusinesses.map((val) => val.id);
    const deletedBusinessesIds = _.difference(
      initialBusinessesIds,
      values.assignedBusinesses
    );

    if (isCreate) {
      values = {
        ...values,
        prices: values.prices.filter(
          (value) =>
            !!initialValues.prices.find(
              (el) =>
                el.product_variant_id === value.product_variant_id &&
                el.price !== value.price
            )
        ),
      };
    }

    const pricesArrayToObject = (arr) =>
      arr.reduce((acc, price) => {
        acc[price.product_variant_id] = price;
        return acc;
      }, {});

    let businessesObj = {};
    summaryData.forEach((obj, i) => {
      obj.businesses.forEach((business) => {
        if (i == index && deletedBusinessesIds.includes(business.id)) {
          return;
        } else if (!businessesObj[business.id]) {
          businessesObj[business.id] = {
            business_id: business.id,
            prices: pricesArrayToObject(obj.prices),
          };
        } else {
          businessesObj[business.id].prices = {
            ...businessesObj[business.id].prices,
            ...pricesArrayToObject(obj.prices),
          };
        }
      });
    });

    values.assignedBusinesses.forEach((businessId) => {
      if (!businessesObj[businessId]) {
        businessesObj[businessId] = {
          business_id: businessId,
          prices: pricesArrayToObject(values.prices),
        };
      } else {
        values.prices.forEach((priceObj) => {
          businessesObj[businessId].prices[priceObj.product_variant_id] =
            priceObj;
        });
      }
    });

    let finalApiStructure = Object.values(businessesObj).map((businessObj) => ({
      ...businessObj,
      prices: Object.values(businessObj.prices),
    }));

    finalApiStructure.map((final) => {
      final.prices.map((variant) => {
        delete variant.label;
        delete variant.name;
        delete variant.is_active;
        delete variant.is_default;
        delete variant.position;
        delete variant.product_id;
        delete variant.barcode;
      });
    });

    finalApiStructure.map((final) => {
      final.prices = final.prices.map((variant) => {
        return {
          ...variant,
          start_time: null,
          end_time: null,
        };
      });
    });

    const validateFinalApiStructure = (finalApiStructure) =>
      !finalApiStructure.prices.length;

    if (finalApiStructure.some(validateFinalApiStructure)) {
      dispatch(
        createAlert({
          type: 'error',
          message: 'Please modify the prices to save the overrides!',
        })
      );
      dispatch({
        type: SUBMIT_PRODUCT_OVERRIDES,
      });
      return;
    }

    if (finalApiStructure.length === 0) {
      dispatch(
        createAlert({
          type: 'error',
          message: 'At least one business needs to be overridden to save',
        })
      );
      return;
    }
    dispatch({
      type: SUBMIT_PRODUCT_OVERRIDES_REQUEST,
    });
    api
      .put(`/menu/products/${productId}/business/override`, {
        businesses: finalApiStructure,
      })
      .then((response) => {
        dispatch({
          type: SUBMIT_PRODUCT_OVERRIDES,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'The product overrides have been successfully saved!',
          })
        );
        cb && cb();
        // setIsOverrideModal({
        //   isShowing: false,
        //   prices: null,
        //   assignedBusinesses: []
        // });
        dispatch(getProductOverrides(productId));
      })
      .catch((error) => {
        dispatch({
          type: SUBMIT_PRODUCT_OVERRIDES,
        });
        dispatch(
          createAlert({
            type: 'error',
            message:
              err?.response?.data?.errors?.message ||
              'An error occurred trying to update the overrides!',
          })
        );
      });
  };
}

export function reassociateProductOverrides(
  productId,
  businesses,
  isDeleted = false,
  showMessage = false
) {
  return function (dispatch) {
    api
      .put(`/menu/products/${productId}/business/override`, {
        businesses: businesses,
      })
      .then(() => {
        dispatch({
          type: SUBMIT_PRODUCT_OVERRIDES,
        });
        if (!showMessage) {
          dispatch(
            createAlert({
              type: 'success',
              message: `The product overrides have been successfully ${
                isDeleted ? 'deleted' : 'updated'
              }!`,
            })
          );
        }
        dispatch(getProductOverrides(productId));
      })
      .catch((err) => {
        dispatch({
          type: SUBMIT_PRODUCT_OVERRIDES,
        });
        if (!showMessage) {
          dispatch(
            createAlert({
              type: 'error',
              message: `An error occurred trying to ${
                isDeleted ? 'delete' : 'update'
              } the overrides!`,
            })
          );
        }
      });
  };
}

export function sortAssignedOptions(optionsList, callback, productId) {
  const modifiedOptions = [];
  optionsList.forEach((eachOption, index) => {
    modifiedOptions.push({
      product_option_id: eachOption?.option_id,
      position: index,
    });
  });
  return function (dispatch) {
    api
      .put(`/menu/products/${productId}/options`, { options: modifiedOptions })
      .then(() => {
        dispatch(getProductOptions(productId));
        callback();
      })
      .catch((err) => {
        callback();
      });
  };
}

export function archiveProduct(productIds, callback) {
  return function (dispatch) {
    return api
      .post('/menu/products/archive', { product_ids: productIds })
      .then((response) => {
        dispatch({
          type: ARCHIVE_PRODUCT_SUCCESS,
          productIds,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product archived successfully.',
          })
        );
        if (callback) callback();
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVE_PRODUCT_FAILURE,
          error,
        });
        dispatch(
          createAlert({
            type: 'error',
            message:
              formatErrorMessage(error) || 'Failed to archive product(s).',
          })
        );
        if (callback) callback(error);
      });
  };
}

export function getArchivedProducts(
  requestParams = { page_number: 1, page_size: 100 }
) {
  return function (dispatch) {
    const urlwithOutSearchString = `menu/products?page_number=${requestParams.page_number}&page_size=${requestParams.page_size}&archived=true`;
    const url = getSearchUrl(
      urlwithOutSearchString,
      requestParams.search_string,
      3
    );
    return api
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_ARCHIVED_PRODUCTS_SUCCESS,
          archivedProducts: response.data.data,
          hasNextPage: response.data.meta.has_next_page,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ARCHIVED_PRODUCTS_FAILURE,
          error,
        });
        dispatch(
          createAlert({
            type: 'error',
            message:
              formatErrorMessage(error) ||
              'Failed to retrieve archived products.',
          })
        );
      });
  };
}

export function unArchiveProduct(productIds, callback) {
  return function (dispatch) {
    return api
      .post('/menu/products/unarchive', { product_ids: productIds })
      .then((response) => {
        dispatch({
          type: UNARCHIVE_PRODUCT_SUCCESS,
          productIds,
        });
        dispatch(
          createAlert({
            type: 'success',
            message: 'Product unarchived successfully.',
          })
        );
        if (callback) callback();
      })
      .catch((error) => {
        dispatch({
          type: UNARCHIVE_PRODUCT_FAILURE,
          error,
        });
        dispatch(
          createAlert({
            type: 'error',
            message:
              formatErrorMessage(error) || 'Failed to unarchive product(s).',
          })
        );
        if (callback) callback(error);
      });
  };
}
